import React, { createContext, useContext, useMemo } from 'react';
import { WebsiteThemeTokens, WEBSITE_DEFAULT_THEME, STORAGE_KEYS, tokensToCssVars } from './tokens';
import { getSiteThemeVariables } from '../utils/contrast';

interface WebsiteThemeContextType {
  theme: WebsiteThemeTokens;
}

const WebsiteThemeContext = createContext<WebsiteThemeContextType>({
  theme: WEBSITE_DEFAULT_THEME,
});

export const useWebsiteTheme = () => useContext(WebsiteThemeContext);

interface WebsiteThemeProviderProps {
  children: React.ReactNode;
  siteSettings?: any;
  websiteId?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const WebsiteThemeProvider: React.FC<WebsiteThemeProviderProps> = ({
  children,
  siteSettings,
  websiteId,
  className = '',
  style,
}) => {
  const theme = useMemo<WebsiteThemeTokens>(() => {
    const computed = getSiteThemeVariables(siteSettings);
    return {
      ...WEBSITE_DEFAULT_THEME,
      ...computed,
    } as WebsiteThemeTokens;
  }, [siteSettings]);

  const cssStyle = useMemo(() => {
    return {
      ...tokensToCssVars(theme as unknown as Record<string, string>),
      fontFamily: siteSettings?.fontFamily || undefined,
      ...style,
    };
  }, [theme, siteSettings, style]);

  return (
    <WebsiteThemeContext.Provider value={{ theme }}>
      <div className={`website-renderer ${className}`} style={cssStyle}>
        {children}
      </div>
    </WebsiteThemeContext.Provider>
  );
};
